import LocalState from '../state/LocalState';

const timeSinceStart = (state: LocalState, time?: number): number => {
  time = typeof time === 'number' ? time : Date.now();
  return time - state.reporter.startTime;
};
export default timeSinceStart;
